(function (window) {
  'use strict';

  const activeTabClass = 'js-card-tabs-tab--active';
  const activeWrapperClass = 'js-card-tabs-content-wrapper--active';

  function initInstance(instance) {
    const tabs = instance.querySelectorAll('.js-card-tabs-tab');

    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', handleTab);
    }
  }

  function handleTab(e) {
    const tab = e.target;
    const instance = tab.closest('.js-card-tabs');
    const tabs = instance.querySelectorAll('.js-card-tabs-tab');
    const contentWrappers = instance.querySelectorAll('.js-card-tabs-content-wrapper');

    for (let i = 0; i < tabs.length; i++) {
      if (tabs[i] == tab) {
        tabs[i].classList.add(activeTabClass);
      }
      else {
        tabs[i].classList.remove(activeTabClass);
      }
    }

    for (let i = 0; i < contentWrappers.length; i++) {
      if (contentWrappers[i].getAttribute('data-tab') == tab.getAttribute('data-tab')) {
        contentWrappers[i].classList.add(activeWrapperClass);
      }
      else {
        contentWrappers[i].classList.remove(activeWrapperClass);
      }
    }
  }

  function init() {
    const instances = document.querySelectorAll('.js-card-tabs');

    for (let i = 0; i < instances.length; i++) {
      if (!instances[i].classList.contains('js-component-init')) {
        initInstance(instances[i]);

        instances[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
